var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddmember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 10.8333H4.99968C4.0693 10.8333 3.60411 10.8333 3.22558 10.9482C2.37331 11.2067 1.70637 11.8736 1.44783 12.7259C1.33301 13.1044 1.33301 13.5696 1.33301 14.5M12.6663 14.5V10.5M10.6663 12.5H14.6663M9.66634 5.5C9.66634 7.15685 8.3232 8.5 6.66634 8.5C5.00949 8.5 3.66634 7.15685 3.66634 5.5C3.66634 3.84315 5.00949 2.5 6.66634 2.5C8.3232 2.5 9.66634 3.84315 9.66634 5.5Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmember);
export default __webpack_public_path__ + "static/media/addmember.4c2e9bdc9dc4b4256eebc1313da85b3a.svg";
export { ForwardRef as ReactComponent };